import React from 'react';
import './utils/webviewBridge';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import { StrictMode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { Global, ThemeProvider } from '@emotion/react';
import global from 'styles/global';
import { theme } from './styles/theme';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store, persistor } from './stores';
import { injectWKWebViewConsoleBridge } from './utils/injectWKWebViewConsoleBridge';

injectWKWebViewConsoleBridge();
// 페이지가 라우트 단위 청크로 나뉘어 있어, 전역 locale 은 어느 페이지로 진입하든 먼저 실행되는 여기서 건다
dayjs.locale('ko');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      retryOnMount: false,
    },
  },
});

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <Global styles={global} />
      <Suspense>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={router} />
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </Suspense>
    </ThemeProvider>
  </StrictMode>,
);
